export const PORTAL_EVENTS = Object.freeze({
  ready: 'redux.ready',
  dispatch: 'redux.dispatch',
});

export const WAIT_PORTAL_DELAY = 300;
export const WAIT_PORTAL_TIMEOUT = 60000;
